import React from "react"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {withFormik} from 'formik';
import {FormattedMessage, injectIntl} from "react-intl";
import {displayErrors, parsePropertiesErrors} from "../../../form-helpers";
import {handleApiResponse} from "../../../crud-actions";
import {downloadDocument} from "../../../../../idoa/app/actions/download";
import ContentShow from "../../content-editor/content-show";
import StarsInput from "../forms/stars";
import AttachmentsList from "../attachments-list";
import ContentUnitHeader from "../content-unit-header";
import BaseComponent from "../../base-component";

class InnerForm extends BaseComponent {

    render() {
        const { intl, values, touched, errors, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, isComplete } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <p><FormattedMessage id='app.personal_forms.message.required_fields'/> (<span className='text-red'>*</span>)</p>
                <hr/>
                { displayErrors(errors, 'base') }

                <div className='form-group'>
                    <FormattedMessage id='app.candidate_feedback_form.feedback_field_1'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                    <StarsInput disabled={isComplete} count={5} value={values.data.feedback_field_1} onChange={(value) => setFieldValue('data.feedback_field_1', value)}/>
                    { displayErrors(errors, 'data.feedback_field_1') }
                </div>

                <div className='form-group'>
                    <FormattedMessage id='app.candidate_feedback_form.feedback_field_2'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                    <StarsInput disabled={isComplete} count={5} value={values.data.feedback_field_2} onChange={(value) => setFieldValue('data.feedback_field_2', value)}/>
                    { displayErrors(errors, 'data.feedback_field_2') }
                </div>

                <div className='form-group'>
                    <FormattedMessage id='app.candidate_feedback_form.feedback_field_3'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                    <StarsInput disabled={isComplete} count={5} value={values.data.feedback_field_3} onChange={(value) => setFieldValue('data.feedback_field_3', value)}/>
                    { displayErrors(errors, 'data.feedback_field_3') }
                </div>

                <div className='form-group'>
                    <FormattedMessage id='app.candidate_feedback_form.feedback_field_4'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                    <StarsInput disabled={isComplete} count={5} value={values.data.feedback_field_4} onChange={(value) => setFieldValue('data.feedback_field_4', value)}/>
                    { displayErrors(errors, 'data.feedback_field_4') }
                </div>

                <div className='form-group'>
                    <FormattedMessage id='app.candidate_feedback_form.feedback_field_5'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                    <textarea disabled={isComplete} rows="6" value={values.data.feedback_field_5} id='data.feedback_field_5' className='form-control' onChange={handleChange} onBlur={handleBlur}/>
                    { displayErrors(errors, 'data.feedback_field_5') }
                </div>

                <div className='form-group'>
                    <FormattedMessage id='app.candidate_feedback_form.feedback_field_6'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                    <textarea disabled={isComplete} rows="6" value={values.data.feedback_field_6} id='data.feedback_field_6' className='form-control' onChange={handleChange} onBlur={handleBlur}/>
                    { displayErrors(errors, 'data.feedback_field_6') }
                </div>

                { !isComplete && <button type='submit' className='btn btn-primary' disabled={isSubmitting}>{intl.formatMessage({id: 'app.actions.save'})}{this.spinner(isSubmitting)}</button> }
            </form>
        )
    }
}

InnerForm = injectIntl(withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        if (props.resource.employee_data) return props.resource.employee_data;

        return {
            data: {
                feedback_field_1: '',
                feedback_field_2: '',
                feedback_field_3: '',
                feedback_field_4: '',
                feedback_field_5: '',
                feedback_field_6: '',
                ...props.resource.data
            }
        }
    },
    handleSubmit: (values, form) => { form.props.submit(values, form); },
    displayName: 'CandidateFeedbackFormInner',
})(InnerForm));

class CandidateFeedbackForm extends React.Component {

    sendForm = (values, form) => {
        let promise = this.props.assignmentUpload('api/v1', this.props.assignment.id, 'submit_form', values.data);
        handleApiResponse('ASSIGNMENT', 'ACTION', promise,
            (result) => {
                this.props.push('/important-documents');
                this.props.setNotification('success', this.props.intl.formatMessage({id: 'app.candidate_feedback_form.message.submit.success'}));
            },
            (result) => {
                this.props.setNotification('warning', this.props.intl.formatMessage({id: 'app.candidate_feedback_form.message.submit.fail'}));
                let errors = result.payload.response.errors;
                errors = parsePropertiesErrors(errors, 'data');
                form.setErrors(errors);
            },
            (error) => {
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
                console.log(error);
            }).then(() => {
            form.setSubmitting(false);
        });
    };

    render() {
        const { assignment } = this.props;
        const contentUnit = assignment.content_unit;
        const isComplete = assignment.state === 'complete';

        return (
            <div>
                <ContentUnitHeader contentUnit={contentUnit}/>
                <div className='container'>
                    <ContentShow contentData={contentUnit.content}/>
                    <hr/>
                    <InnerForm resource={assignment} submit={this.sendForm} isComplete={isComplete}/>
                    <AttachmentsList contentUnit={contentUnit}/>
                </div>
            </div>
        )
    };
}

function mapStateToProps(state,ownProps) {
    return {
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        downloadDocument: downloadDocument,
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, matchDispatchToProps)(CandidateFeedbackForm));
